import Component from './Dashboard';

export default Component;
